import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { debounceTime, tap, switchMap, finalize, distinctUntilChanged, filter, takeUntil, map } from 'rxjs/operators';
import { FormControl, NgForm, ControlContainer, NgModel } from '@angular/forms';
import { Summary, CardImage } from '../objects/SummaryObject';
import { DetailProperty } from '../objects/DetailObject';
import { Subject, Subscription, fromEvent } from 'rxjs';
import { MatChipInputEvent, MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';

@Component({
  selector: 'app-property-summary',
  templateUrl: './property-summary.component.html',
  styleUrls: ['./property-summary.component.css'],
  viewProviders: [ 
    { provide: ControlContainer, useExisting: NgForm } ]
})
export class PropertySummaryComponent implements OnInit, OnDestroy {

  @Input() submitted:boolean;
  @Input() set suggestSummary(property: any){
    // ex: type|summaryName
    this.isBusy = true;
    this.summaryService.getBasicSummary(property.PropertyDisplayFormat.split('|')[0], property.PropertyDisplayFormat.split('|')[1]).subscribe(result => {
      if (result){
        this.componentId = result;
        this.isPropertySummary = true;
        this.propertySummary = property;
      }
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    })
  }
  
  @Output() propertySuggest = new EventEmitter<string>();

  formControl = new FormControl();
  isBusy: boolean;
  componentId: string;
  isPropertySummary: boolean;
  propertySummary?: DetailProperty;
  isPropertyLoading: boolean;
  summary: Summary;
  imageId: string[];
  imageObject : any[];
  isImageLoad: boolean;
  subscription: Subscription;
  selectedData: any = [];
  separatorKeysCodes: number[] = []; // to disable the enter key in input
  value: any;
  summaryLayout: string;
  isFetching: boolean;
  nextDataLength: number = 0;
  nextImageId: string[];
  nextImageObject: any[];
  currentCardImage: CardImage[];
  
  searchTextChanged = new Subject<string>();
  
  @ViewChild('textbox') textInput: ElementRef;
  @ViewChild('autoComplete') autoCompleteRef: MatAutocomplete;
  @ViewChild('trigger', {read: MatAutocompleteTrigger}) matAutocomplete: MatAutocompleteTrigger;
  @ViewChild('chipList') chipList;
  @ViewChild('loadMore') loadMore : ElementRef;
  
  constructor(private summaryService: SummaryService) {}

  ngOnInit() {
    // for reactive form
    // this.formControl.valueChanges
    // .pipe(
    //   debounceTime(300),
    //   tap((value) => {
    //     typeof value == "object" ? this.propertySuggest.emit(value[this.retrieveFilteredData('ID')]) : this.propertySuggest.emit(value);
    //     this.isPropertyLoading = true
    //   }
    //   ),
    //   switchMap(value => this.summaryService.searchAndReturnSummary(this.componentId, typeof value == "object" ? value[this.retrieveFilteredData('prop1')] : value).pipe(
    //     finalize(() => {
    //       this.isPropertyLoading = false
    //     }),
    //     )
    //   )
    // ).subscribe(result => {
    //   this.summary = JSON.parse(result);
    //   console.log(this.summary);

    //   const filteredSummary = this.summary;
    //   this.imageObject = [];
    //   this.imageId = [];
    //   filteredSummary.Data.forEach(element => {
    //     // set the id
    //     if (element[this.retrieveFilteredData('Image')] != null)
    //     {
    //       let docId = element[this.retrieveFilteredData('ID')];
    //       let array = element[this.retrieveFilteredData('Image')].split(",");
    //       array.forEach(imageId => {
    //         if (!imageId){
    //           imageId = '00000000-0000-0000-0000-000000000000';
    //         }
    //         this.imageId.push(imageId);
    //         this.imageObject.push({docId, imageId});
    //       });
    //     }
    //   });

    //   this.getAllImage(true);

    // })

    // for template driven form
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(x => x != null),
      tap((value) => {
        this.handleEmitValue(value);
        this.isPropertyLoading = true
      }
      ),
      switchMap(value => this.summaryService.searchAndReturnSummary(this.componentId, typeof value == "object" ? value[this.retrieveFilteredData('prop1')] : value.trim()))
    ).subscribe(result => {
      this.isPropertyLoading = false
      this.summary = JSON.parse(result);
      this.summaryLayout = this.summary.CardLayoutProperties[0].LayoutType.toUpperCase();
      const filteredSummary = this.summary;
      this.imageObject = [];
      this.imageId = [];
      filteredSummary.Data.forEach(element => {
        // set the id
        if (element[this.retrieveFilteredData('Image')] != null)
        {
          let docId = element[this.retrieveFilteredData('ID')];
          let array = element[this.retrieveFilteredData('Image')].split(",");
          array.forEach(imageId => {
            if (!imageId){
              imageId = '00000000-0000-0000-0000-000000000000';
            }
            this.imageId.push(imageId);
            this.imageObject.push({docId, imageId});
          });
        }
      });

      this.getAllImage();
    })
  }

  sortSummaryData(summary: Summary): any{
    return summary.Data.sort((a:any,b:any) => { 
      if(parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])){
        return 1;
      }else if(parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])){
        return -1;
      }else{
        return 0;
      }
     });
  }

  handleEmitValue(value: any){
    if (value){
      this.chipList.errorState = false
    }
    else{
      this.selectedData.length == 0 ? this.chipList.errorState = true : this.chipList.errorState = false;
    }

    if(!this.chipList.errorState){
      if (this.selectedData.length == 0){
        this.propertySuggest.emit(value.trim());
      }
    } 
  }

  onValueChange($event){
    if (typeof $event == "object"){
      this.propertySuggest.emit($event[this.retrieveFilteredData('ID')])
      
    }
    else{
      this.searchTextChanged.next($event);
    }
  }

  displayFn(data?): string | undefined {
    return data ? data[this.retrieveFilteredData('prop1')] : undefined;
  }

  retrieveFilteredData(cardProperty: string): string {
    if (this.summary != null){
      if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
        return this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).PropertyName;
      }  
    }
  }

  getAllImage(scrollToTop:boolean = false) {
    if (this.imageObject){
      if (this.imageId.length > 0) {
        this.isImageLoad = true;
        this.promiseImage(this.imageId).then(chunk => {
          this.currentCardImage = chunk;
          this.summary.CardImageList = chunk;
          if (scrollToTop){
            setTimeout(() => {
              this.autoCompleteRef._setScrollTop((this.summary.Data.length - this.nextDataLength) * 75);
            })
          }
        });
      }
    }
  }

  promiseImage(imageIds: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      var list = [];
      this.summaryService.getAllImage(this.imageId).subscribe(results => {
        var index = 0;
        for(let result of results) {
          result = new Blob([result], {type: 'image/jpg'});
          let docId = this.imageObject.find(x => x.imageId == this.imageId[index]).docId;
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            list.push({
              DocumentId : docId,
              ImageId : this.imageId[index],
              Blob : reader.result
            });

          }, false);
      
          if (result) {
            reader.readAsDataURL(result);
          }
          index++;
        }

        setTimeout(()=>{
          this.isImageLoad = false;
        }, 100)
      });
      resolve(list);
    });
  }

  getImageFilteredSummary(id : string): any {
    if (this.summary.CardImageList != null) {
      if (this.summary.CardImageList.find(x => x.DocumentId == id) != null){
        if(this.summary.CardImageList.find(x => x.DocumentId == id).Blob){
          return this.summary.CardImageList.find(x => x.DocumentId == id).Blob;
        }
        else {
          return null;
        }
      }
    }
  }

  onSelectionChanged($event){
    if ($event.option.value){
      this.selectedData = [];
      this.selectedData.push($event.option.value);
      this.propertySummary.PropertyValue = $event.option.value[this.retrieveFilteredData('prop1')];
      this.textInput.nativeElement.value = '';
      this.chipList.errorState = false;
    }
  }

  onLoadMore($event){
    $event.stopPropagation();
    if (!this.isFetching){
      this.isFetching = true;
      this.fetchNextChunk().then(chunk => {
        this.isFetching = false;
        this.nextDataLength = chunk.Data.length - this.summary.Data.length;
        this.summary = chunk;
        this.loadMoreImages();
      });
    }
  }

  fetchNextChunk(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.summaryService.nextPage(this.componentId).subscribe(result => {
        if (result == "1"){
          this.summaryService.getSummary(this.componentId).subscribe(result=> {
            this.summary.CurrentPage = this.summary.CurrentPage + 1;
            var summary = JSON.parse(result);
            summary = this.handleNewSummary(summary);
            resolve(summary);
          })
        }
      });
    });
  }

  handleNewSummary(summary: Summary){
    if (summary.Data.length > 0) {
      this.nextImageObject = [];
      this.nextImageId = [];
      summary.Data.forEach(element => {
        // set the id
        if (element[this.retrieveFilteredData('Image')] != null)
        {
          let docId = element[this.retrieveFilteredData('ID')];
          let array = element[this.retrieveFilteredData('Image')].split(",");
          array.forEach(imageId => {
            if (!imageId){
              imageId = '00000000-0000-0000-0000-000000000000';
            }

            if (this.imageId.indexOf(imageId) > -1){
              this.imageId.push(imageId);
              this.imageObject.push({docId, imageId});
            }
            else{
              this.nextImageId.push(imageId);
              this.nextImageObject.push({docId, imageId});
            }
          });
        }
      });
    }

    summary.Data = this.sortSummaryData(summary);
    return summary;
  }

  // performance experimental fix
  loadMoreImages(){
    if (this.nextImageObject){
      if (this.nextImageId.length > 0) {
        this.isImageLoad = true;
        this.promiseNextImage(this.nextImageId, this.nextImageObject).then(chunk => {
          this.summary.CardImageList = chunk;
          
          setTimeout(() => {
            this.autoCompleteRef._setScrollTop((this.summary.Data.length - this.nextDataLength - 1) * 75);
          })
        });
      }
    }
  }

  promiseNextImage(imageIds: any, imageObject: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      var list = this.currentCardImage;
      this.summaryService.getAllImage(imageIds).subscribe(results => {
        var index = 0;
        for(let result of results) {
          result = new Blob([result], {type: 'image/jpg'});
          let docId = imageObject.find(x => x.imageId == imageIds[index]).docId;
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            list.push({
              DocumentId : docId,
              ImageId : imageIds[index],
              Blob : reader.result
            });

          }, false);
      
          if (result) {
            reader.readAsDataURL(result);
          }
          index++;
        }
      });
      
      resolve(list);
    });
  }

  // add(event: MatChipInputEvent): void {
  //   // Add data only when MatAutocomplete is not open
  //   // To make sure this does not conflict with OptionSelected Event
  //   if (!this.matAutocomplete.isOpen) {
  //     const input = event.input;
  //     const value = event.value;
  //     // Add selected data
  //     if ((value || '').trim()) {
  //       this.selectedData.push(value.trim());
  //     }

  //     // Reset the input value
  //     if (input) {
  //       input.value = '';
  //     }
  //   }
  // }

  remove(data: string): void {
    this.selectedData.forEach(element => {
      if (element){

      }
    });
    this.selectedData = [];
    if (this.textInput.nativeElement.value){
      this.propertySuggest.emit(this.propertySummary.PropertyValue);
    }
    else{
      this.propertySummary.PropertyValue = '';
    }

    this.textInput.nativeElement.focus();
    
    if (this.matAutocomplete){
      this.matAutocomplete.closePanel();
    }

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
}
